<template>
    <div>

        <!-- btns -->
        <div class="TQ_grid_col_1frAuto TQ_center TQ_text_20px" :style="{maxWidth: co_questList_maxWidth_s}">

            <!-- tabs -->
            <div class="TQ_align_initial TQ_inline TQ_text_capitalize" v-if="p_showMap_b">

                <div class="TQ_inline TQ_padding_8px TQ_bg_white TQ_box_shadow TQ_clickable TQ_center TQ_width_100px"
                     :class="[co_direction_ltr_b ? 'TQ_borderRadius_left' : 'TQ_borderRadius_right', selectTabIndex_n === 0 && 'TQ_bg_purple']"
                     @click="selectTabIndex_n = 0">
                    {{ass_strings.oneWord_list[p_systemLangCode_e]}}
                </div>

                <div  class="TQ_inline TQ_padding_8px TQ_bg_white TQ_box_shadow TQ_clickable TQ_center  TQ_width_100px"
                     @click="selectTabIndex_n = 1"
                     :class="[co_direction_ltr_b ? 'TQ_borderRadius_right' : 'TQ_borderRadius_left' , selectTabIndex_n === 1 && 'TQ_bg_purple']">
                    {{ass_strings.oneWord_map[p_systemLangCode_e]}}
                </div>

            </div>

            <!-- filter -->
            <div class="TQ_align_end">
                <div @click="() => {showPopup_mobileFilter_vb.val = true}"
                     class="TQ_center TQ_bg_purple TQ_box_shadow TQ_padding_8px TQ_borderRadius TQ_inline TQ_textColor_white TQ_clickable">

                    <div class="TQ_grid_col_1frAuto TQ_grid_gap_4px">
                        <tq-image :pb_src_r="ass_img_filter_w"
                                  :pb_att_s="ass_strings.oneWord_filter[p_systemLangCode_e]" class="TQ_grid_center TQ_width_20px"/>

                        <div class="TQ_grid_center">{{ass_strings.oneWord_filter[p_systemLangCode_e]}}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Quest List -->
        <div v-if="selectTabIndex_n===0" class="TQ_margin_top_8px">

            <!-- quests -->
            <div v-if="co_filterQuestExplore_ac.length > 0" class="TQ_inline TQ_padding_8px TQ_width_100p TQ_borderBox TQ_maxWidth_350px"
                 v-for="(questExplore_c, index_n) in co_filterQuestExplore_ac.slice(0,displayQuestNum_n)" :key="index_n">
                <div class="TQ_bg_white TQ_borderRadius TQ_width_100p">
                    <tq-link :p_link_s="paths_byQuestId_s[questExplore_c.qex_questId_uid]" class="TQ_text_remove_underline TQ_textColor_black">
                        <tq-quest-explore-header
                            :pb_created-user-data_c="p_creatorsData_byUserId_c[questExplore_c.qex_creatorId_uid]"
                            :pb_quest-explore-info_c="p_questExploreInfo_byQuestId_c[questExplore_c.qex_questId_uid]"
                            :pb_quest-explore_c="questExplore_c"

                            :ps_lang-code_e="p_systemLangCode_e"
                            :p_system_current-currency_e="p_systemCurrency_e"
                            :ps_screenSize_en="p_systemWindowSizeType_e"

                            :pf_loved-quest_b="p_lovedQuests_byQuestId_c[questExplore_c.qex_questId_uid] != null"
                            :pf_small-mode_b="true"

                            :pe_click-heart_fe="() => {pe_clickLoveQuest_f(questExplore_c)}"
                        />
                    </tq-link>
                </div>
            </div>


            <!-- no quest text -->
            <div v-else class="TQ_text_32px TQ_textColor_purple TQ_padding_8px">
                {{ass_strings.sentence_notQuestsToDisplay[p_systemLangCode_e]}}.
            </div>

            <!-- load more quest btn -->
            <div>
                <tq-loader-button :show-loader="p_moreQuestBtnLoader_b"
                                  v-if="co_showLoadMoreQuestsBtn_b"
                                  @click.native="m_loadMoreQuest_f"
                                  class="TQ_padding_8px TQ_bg_purple TQ_borderRadius TQ_margin_8px TQ_inline TQ_box_shadow TQ_text_20px TQ_clickable TQ_text_capitalize">
                    {{ass_strings.threeWords_loadMoreQuests[p_systemLangCode_e]}}
                </tq-loader-button>
            </div>


            <!-- space -->
            <div class="TQ_padding_16px TQ_margin_16px" v-if="p_systemWindowSizeType_e.val === enum_screenSizesOptions_n.mobile"></div>

        </div>

        <!-- map -->
        <div v-if="selectTabIndex_n===1"
             :style="{maxWidth: co_questList_maxWidth_s}"
             class="TQ_padding_4px TQ_bg_white TQ_inline TQ_margin_top_4px TQ_width_100p TQ_borderRadius TQ_borderBox" >

            <tq-leaflet-display-simple class="TQ_center TQ_width_100p TQ_height_600px TQ_maxHeight_80vh"
                                       v-if="startingLocation_c"

                                       :p_display_lang-code_e="p_systemLangCode_e"
                                       :pb_center-map_c="startingLocation_c"
                                       :p_markers_ac="co_markets_ac"
                                       :pb_zoom_n="12"

                                       :pe_change-bonds_f="m_changeBounds_f"
                                       :pe_on-click-marker_f="m_clickOnMarker_f"

            />
        </div>

        <!-- popup - filters-->
        <tq-popup :show="showPopup_mobileFilter_vb" width="100%" padding="0" maxWidth="400px" class="TQ_center " :show-close-btn="true">

            <div class="TQ_bg_gray4 ">
                <!-- title -->
                <div class="TQ_text_28px TQ_bg_purple_dark TQ_text_bold TQ_padding_8px">
                    {{ass_strings.oneWord_filter[p_systemLangCode_e]}}
                </div>

                <div class="TQ_padding_16px TQ_bg_white">

                    <!-- Quest Title -->
                    <div class="TQ_margin_bottom_16px  ">
                        <div class="TQ_align_initial TQ_text_bold TQ_text_capitalize">
                            {{ass_strings.twoWords_questTitle[p_systemLangCode_e]}}
                        </div>
                        <input class="TQ_padding_8px TQ_text_18px TQ_border_gray TQ_width_100p TQ_borderBox TQ_verticalAlignBottom TQ_borderRadius"
                               v-model="newFilter_o.title_s"
                               :placeholder="ass_strings.oneWord_search[p_systemLangCode_e] + '...' ">
                    </div>

                    <!-- Type  -->
                    <div class="TQ_margin_bottom_16px TQ_align_initial" >
                        <div class="TQ_align_initial TQ_text_bold ">
                            {{ass_strings.oneWord_type[p_systemLangCode_e]}}
                        </div>

                        <div class="TQ_grid_col_1fr1fr1fr TQ_grid_gap_2px TQ_center  TQ_clickable TQ_direction_ltr TQ_text_capitalize">
                            <div class="TQ_padding_8px TQ_bg_gray4 TQ_borderRadius_left"
                                 :class="newFilter_o.questTypeIndex_an.includes(0) && 'TQ_bg_black'"
                                 @click="newFilter_o.questTypeIndex_an = [0]" >{{ass_strings.oneWord_all[this.p_systemLangCode_e]}}</div>
                            <div class="TQ_padding_8px TQ_bg_gray4"
                                 :class="newFilter_o.questTypeIndex_an.includes(1) && 'TQ_bg_black'"
                                 @click="newFilter_o.questTypeIndex_an = [1]">{{ass_strings.oneWord_virtual[this.p_systemLangCode_e]}}</div>
                            <div class="TQ_padding_8px TQ_bg_gray4 TQ_borderRadius_right "
                                 :class="newFilter_o.questTypeIndex_an.includes(2) && 'TQ_bg_black'"
                                 @click="newFilter_o.questTypeIndex_an = [2]">{{ass_strings.oneWord_outside[this.p_systemLangCode_e]}}</div>
                        </div>

                    </div>

                    <!-- Guide -->
                    <div class="TQ_margin_bottom_16px TQ_align_initial " >
                        <div class="TQ_align_initial TQ_text_bold ">
                            {{ass_strings.oneWord_guide[p_systemLangCode_e]}}
                        </div>


                        <div class="TQ_grid_col_1fr1fr1fr TQ_grid_gap_2px TQ_center TQ_clickable TQ_direction_ltr TQ_text_capitalize">
                            <div class="TQ_padding_8px TQ_bg_gray4 TQ_borderRadius_left"
                                 :class="newFilter_o.questGuideIndex_an.includes(0) && 'TQ_bg_black'"
                                 @click="newFilter_o.questGuideIndex_an = [0]" >{{ass_strings.oneWord_all[this.p_systemLangCode_e]}}</div>
                            <div class="TQ_padding_8px TQ_bg_gray4"
                                 :class="newFilter_o.questGuideIndex_an.includes(1) && 'TQ_bg_black'"
                                 @click="newFilter_o.questGuideIndex_an = [1]">{{ass_strings.oneWord_guide[this.p_systemLangCode_e]}}</div>
                            <div class="TQ_padding_8px TQ_bg_gray4 TQ_borderRadius_right "
                                 :class="newFilter_o.questGuideIndex_an.includes(2) && 'TQ_bg_black'"
                                 @click="newFilter_o.questGuideIndex_an = [2]">{{ass_strings.oneWord_independently[this.p_systemLangCode_e]}}</div>
                        </div>

                    </div>

                    <!-- Language -->
                    <div class="TQ_margin_bottom_16px" >
                        <div class="TQ_align_initial TQ_text_bold ">
                            {{ass_strings.oneWord_language[p_systemLangCode_e]}}
                        </div>
                        <tq-dropdown class=" TQ_border_gray TQ_align_initial TQ_width_100p TQ_borderRadius" max-height="200px" :p_only-upward_b="true">
                            <div slot="select" class="TQ_padding_8px TQ_align_initial">
                                <div v-if="newFilter_o.langCode_e" class="TQ_grid_col_1frAuto">
                                    <div class="TQ_grid_verticalCenter">{{format_langCode_fs(newFilter_o.langCode_e)}}</div>
                                    <tq-image :pb_src_r="file_getLangFlagByLangCode_fr(newFilter_o.langCode_e)" class="TQ_grid_verticalCenter TQ_width_24px"></tq-image>
                                </div>
                                <div v-else class="TQ_grid_col_1frAuto">
                                    {{ass_strings.twoWords_allLanguages[p_systemLangCode_e]}}
                                </div>
                            </div>

                            <div slot="options" @click="newFilter_o.langCode_e = null"
                                 :class="newFilter_o.langCode_e == null && 'TQ_bg_gold_lite'"
                                 class="TQ_padding_8px TQ_border_top TQ_grid_col_1frAuto">
                                {{ass_strings.twoWords_allLanguages[p_systemLangCode_e]}}
                            </div>

                            <div slot="options" v-for="langCode_e in enum_langCodes"
                                 :class="newFilter_o.langCode_e === langCode_e && 'TQ_bg_gold_lite'"
                                 class="TQ_padding_8px TQ_border_top TQ_grid_col_1frAuto" @click="newFilter_o.langCode_e = langCode_e">
                                <div>{{format_langCode_fs(langCode_e)}}</div>
                                <tq-image :pb_src_r="file_getLangFlagByLangCode_fr(langCode_e)" class="TQ_width_24px"></tq-image>
                            </div>
                        </tq-dropdown>
                    </div>

                    <!-- Diff Level -->
                    <div class="TQ_margin_bottom_16px">
                        <div class="TQ_align_initial TQ_text_bold  ">
                            {{ass_strings.twoWords_diffLevel[p_systemLangCode_e]}}
                        </div>
                        <tq-dropdown class=" TQ_inline TQ_border_gray TQ_align_initial TQ_width_100p TQ_borderRadius" max-height="300px" :p_only-upward_b="true">

                            <div slot="select" class="TQ_padding_12px TQ_align_initial">
                                <div v-if="newFilter_o.diffLevel_n" class="TQ_grid_col_1frAuto">
                                    <div class="TQ_grid_verticalCenter">{{helper_getDiffLevel_o(newFilter_o.diffLevel_n, p_systemLangCode_e).text_s}}</div>
                                    <tq-image :pb_src_r="helper_getDiffLevel_o(newFilter_o.diffLevel_n, p_systemLangCode_e).img_r" class="TQ_width_32px TQ_grid_verticalCenter"> </tq-image>
                                </div>
                                <div v-else >
                                    {{ass_strings.twoWords_allLevels[p_systemLangCode_e]}}
                                </div>
                            </div>

                            <div slot="options" @click="newFilter_o.diffLevel_n = null"
                                 :class="newFilter_o.diffLevel_n == null && 'TQ_bg_gold_lite'"
                                 class="TQ_padding_12px TQ_border_top TQ_grid_col_1frAuto ">
                                <div class="TQ_grid_center">{{ass_strings.twoWords_allLevels[p_systemLangCode_e]}}</div>
                            </div>
                            <div slot="options" v-for="diffLevel_n in [5,4,3,2,1]" @click="newFilter_o.diffLevel_n = diffLevel_n"
                                 :class="newFilter_o.diffLevel_n == diffLevel_n && 'TQ_bg_gold_lite'"
                                 class="TQ_border_top TQ_padding_12px TQ_grid_col_1frAuto">
                                <div class="TQ_grid_center">{{helper_getDiffLevel_o(diffLevel_n, p_systemLangCode_e).text_s}}</div>
                                <tq-image :pb_src_r="helper_getDiffLevel_o(diffLevel_n, p_systemLangCode_e).img_r" class="TQ_width_32px TQ_grid_center"> </tq-image>
                            </div>
                        </tq-dropdown>
                    </div>

                    <hr>
                    <!-- search btn -->
                    <div @click="m_filterQuestExplore_f" class="TQ_padding_8px TQ_bg_purple TQ_text_20px TQ_borderRadius TQ_box_shadow TQ_clickable TQ_grid_col_1frAuto">
                        <div class="TQ_grid_center">{{ass_strings.oneWord_Continue[p_systemLangCode_e]}} </div>
                        <div v-if="co_changeFilters_b" class="TQ_animation_beacon TQ_padding_4px TQ_square_8px TQ_bg_circle TQ_grid_center"></div>
                    </div>

                </div>

            </div>


        </tq-popup>

    </div>

</template>

<script>
import TqCard from "@/components/basic/TqCard";
import TqLink from "@/components/basic/TqLink";
import TqQuestExploreHeader from "@/components/complex/TqQuestExploreHeader";
import {
    enum_costCurrency_n, enum_directions,
    enum_langCodes,
    enum_moveToOptions, enum_questLocationsTypes_s,
    enum_screenSizesOptions_n
} from "../../../../functions/src/shareCode/Share_S_Enum";
import {
    validator_arrayClass_fb,
    validator_enum_fb,
    validator_objClass_fb
} from "../../../../functions/src/shareCode/Share_S_Validator";
import {
    FB_MapPoint,
    FB_QuestExplore,
    FB_QuestExplore_Info,
    FB_QuestPointer
} from "../../../../functions/src/shareCode/Share_S_Classes";
import {ass_strings} from "../../../../functions/src/shareCode/Share_Ass_Dictionary";
import TqLoaderButton from "@/components/basic2/TqLoaderButton";
import {obj_deepCopy_f, obj_equals_fb} from "../../../../functions/src/shareCode/Share_S_Obj";
import {ass_img_filter_w, ass_img_searchEmpty_w} from "@/assets/scripts/Ass_Files";
import {helper_getDiffLevel_o, helper_getDirectionByLangCode_fe} from "@/scripts/S_Helper";
import {format_langCode_fs} from "../../../../functions/src/shareCode/Share_S_Format";
import {file_getLangFlagByLangCode_fr} from "@/scripts/S_Files";
import TqImage from "@/components/basic/TqImage";
import TqDropdown from "@/components/basic/TqDropdown";
import TqToggleMultiOptions from "@/components/basic/TqToggleMultiOptions";
import TqPopup from "@/components/basic/TqPopup";
import TqBeacon from "@/components/basic2/TqBeacon";
import TqLeafletDisplaySimple from "@/components/maps/TqLeafletDisplaySimple";
import {mao_geoHash_lastHash_fs, map_geoHash_bboxes_fp, map_getLocationWithIp_fp} from "@/scripts/API/S_Map";
import {Tq_Laeflet_Marker} from "@/classes/TqClasses";
import {route_moveToRoute} from "@/router";
import {server_questGeoHash_withGeoHashFilter_getAll_fp} from "@/scripts/Server/S_ServerPre";

export default {
    name: "c_Player_Store_List",
    components: {
        TqLeafletDisplaySimple,
        TqBeacon,
        TqPopup,
        TqToggleMultiOptions, TqDropdown, TqImage, TqLoaderButton, TqQuestExploreHeader, TqLink, TqCard},
    props:{
        p_moreQuestBtnLoader_b : {
            type:Boolean,
            require: true,
        },

        // store
        p_systemCurrency_e : {
            require: true,
            validator(val){
                return validator_enum_fb(enum_costCurrency_n, val)
            }
        },
        p_systemLangCode_e : {
            require: true,
            validator(val){
                return validator_enum_fb(enum_langCodes, val)
            }
        },
        p_systemWindowSizeType_e : {
            require: true,
            validator(val){
                return validator_enum_fb(enum_screenSizesOptions_n, val)
            }
        },
        p_screenWidth_n: {
            require: true,
            type: Number
        },
        p_showMap_b : {
            type: Boolean,
            default : true
        },
        p_linkPrefix_e:{
            type:String,
            default: enum_moveToOptions.player_store_quest
        },

        // server
        p_questsExplore_ac:{
            require: true,
            validator(val){
                return validator_arrayClass_fb(val, FB_QuestExplore)
            }
        },
        p_creatorsData_byUserId_c: {
            require: true,
        },
        p_questExploreInfo_byQuestId_c: {
            require: true,
            validator(val){
                return validator_objClass_fb(val, FB_QuestExplore_Info)
            }
        },
        p_lovedQuests_byQuestId_c: {
            require: true,
            validator(val){
                return validator_objClass_fb(val, FB_QuestPointer)
            }
        },

        // functions
        pe_clickLoveQuest_f:{
            type: Function,
            require: true,
        },

    },
    data(){
        return {
            displayQuestNum_n           : 0,
            addDisplayQuestNum_n        : this.p_systemWindowSizeType_e > enum_screenSizesOptions_n.mobile ? 12 : 4,
            selectTabIndex_n            : 0,
            startingLocation_c          : undefined,
            mapLastIndexClick_n         : null,

            showPopup_mobileFilter_vb   : {val : false},

            newFilter_o : {
                title_s   : "",
                questTypeIndex_an   : [0],
                questGuideIndex_an  : [0],
                langCode_e          : this.p_systemLangCode_e === enum_langCodes.english ? enum_langCodes.english : null,
                diffLevel_n         : null,

            },
            currentFilters_o : {
                title_s   : "",
                questTypeIndex_an   : [0],
                questGuideIndex_an  : [0],
                langCode_e          : this.p_systemLangCode_e === enum_langCodes.english ? enum_langCodes.english : null,
                diffLevel_n         : null,

            },

            paths_byQuestId_s : {},

            server_oldGeoHash_byHash_s          : {},
            server_questGeoHash_byQuestId_c          : {},

            // imports
            ass_strings                     : ass_strings,
            enum_screenSizesOptions_n       : enum_screenSizesOptions_n,
            ass_img_filter_w                : ass_img_filter_w,
            ass_img_searchEmpty_w           : ass_img_searchEmpty_w,
            enum_langCodes                  : enum_langCodes,
            helper_getDiffLevel_o           : helper_getDiffLevel_o,
            format_langCode_fs              : format_langCode_fs,
            file_getLangFlagByLangCode_fr   : file_getLangFlagByLangCode_fr,


        }
    },
    computed: {
        co_arrangeQuestsExplore_ac(){

            return this.p_questsExplore_ac.sort((questExplore1_c, questExplore2_c) => {

                if(questExplore1_c.qex_metadata_c.qeam_closedQuest_b){
                    return 1
                }

                if(questExplore2_c.qex_metadata_c.qeam_closedQuest_b){
                    return -1
                }

                let questExploreInfo1_c = this.p_questExploreInfo_byQuestId_c[questExplore1_c.qex_questId_uid]
                let questExploreInfo2_c = this.p_questExploreInfo_byQuestId_c[questExplore2_c.qex_questId_uid]

                if(!questExploreInfo1_c || !questExploreInfo2_c){
                    return 0
                }


                if(questExploreInfo1_c.qexi_participated_n > questExploreInfo2_c.qexi_participated_n){
                    return -1
                }

                if(questExploreInfo2_c.qexi_participated_n > questExploreInfo1_c.qexi_participated_n){
                    return 1
                }

                if(Math.round(questExploreInfo1_c.qexi_overallRatingAvg_n) > Math.round(questExploreInfo2_c.qexi_overallRatingAvg_n)){
                    return -1
                }

                if(Math.round(questExploreInfo2_c.qexi_overallRatingAvg_n) > Math.round(questExploreInfo1_c.qexi_overallRatingAvg_n)){
                    return 1
                }


                return 0
            })
        },
        co_filterQuestExplore_ac(){
            let ans  = this.co_arrangeQuestsExplore_ac

            // langCode
            if(this.currentFilters_o.title_s != null) {
                ans = ans.filter(questExplore_c => {

                    let ans_b = false

                    for (let langCode_e in questExplore_c.qex_name_byLangCode_s) {
                        ans_b = ans_b || questExplore_c.qex_name_byLangCode_s[langCode_e].toLowerCase().includes(this.currentFilters_o.title_s)
                    }
                    return ans_b
                })
            }

            // quest type
            if(this.currentFilters_o.questTypeIndex_an[0] > 0){
                ans = ans.filter(questExplore_c => {
                    if(this.currentFilters_o.questTypeIndex_an[0] === 1 ){ // virtual
                        return questExplore_c.qex_metadata_c.qexm_questLocationType_e === enum_questLocationsTypes_s.virtual
                    }else{
                        return questExplore_c.qex_metadata_c.qexm_questLocationType_e === enum_questLocationsTypes_s.outside
                    }
                })
            }

            // guide
            if(this.currentFilters_o.questGuideIndex_an[0] > 0){
                ans = ans.filter(questExplore_c => {
                    if(this.currentFilters_o.questGuideIndex_an[0] === 1 ){ // guided
                        return questExplore_c.qex_metadata_c.qexm_guide_b
                    }else{
                        return !questExplore_c.qex_metadata_c.qexm_guide_b
                    }
                })
            }

            // langCode
            if(this.currentFilters_o.langCode_e != null){
                ans = ans.filter(questExplore_c => {return questExplore_c.qex_langArr_ae.includes(this.currentFilters_o.langCode_e)})
            }

            // diff level
            if(this.currentFilters_o.diffLevel_n != null){
                ans = ans.filter(questExplore_c => {return Math.round(this.server_questExploreInfo_byQuestId_c[questExplore_c.qex_questId_uid].qexi_difficultyAvg_n) === this.currentFilters_o.diffLevel_n})
            }

            return ans;
        },

        co_showLoadMoreQuestsBtn_b(){
            return this.displayQuestNum_n < this.co_filterQuestExplore_ac.length
        },
        co_direction_ltr_b(){
            return helper_getDirectionByLangCode_fe(this.p_systemLangCode_e) === enum_directions.ltr
        },

        co_questList_maxWidth_s(){

            let gap_n = 42
            if(this.p_screenWidth_n >= 1775){
                return (1775 - gap_n) + "px"
            }else if(this.p_screenWidth_n >= 1422){
                return (1422 - gap_n) + "px"
            }else if(this.p_screenWidth_n >= 1075){
                return (1075 - gap_n) + "px"
            }else if(this.p_screenWidth_n >= 724){
                return (724 - gap_n) + "px"
            }else{
                return (380 - gap_n) + "px"
            }
        },
        co_markets_ac(){

            let ans_ac = []

            for(let questId_uid in this.server_questGeoHash_byQuestId_c){
                let questGeoHash_c = this.server_questGeoHash_byQuestId_c[questId_uid]
                ans_ac.push(new Tq_Laeflet_Marker({
                    ltm_text_s : questGeoHash_c.qg_m_questName_s(this.p_systemLangCode_e),
                    ltm_color_s: "green",
                    ltm_location_c : questGeoHash_c.qg_startingLocation_c,
                    ltm_id_s : questId_uid
                    // ltm_location_c : new FB_MapPoint({mp_lat_n : 32, mp_lng_n : 35})
                }))
            }

            return ans_ac
        },

        co_changeFilters_b(){
            return !obj_equals_fb(this.currentFilters_o, obj_deepCopy_f(this.newFilter_o))
        },

    },
    methods : {
        m_loadMoreQuest_f(){

            if(this.displayQuestNum_n + this.addDisplayQuestNum_n < this.co_filterQuestExplore_ac.length){
                this.displayQuestNum_n += this.addDisplayQuestNum_n
            }else{
                this.displayQuestNum_n = this.co_filterQuestExplore_ac.length
            }
        },
        m_filterQuestExplore_f(){
            this.currentFilters_o = obj_deepCopy_f(this.newFilter_o)
            this.showPopup_mobileFilter_vb.val = false
        },
        m_clickOnMarker_f(index_n){

            if(this.mapLastIndexClick_n === index_n){
                route_moveToRoute(this.paths_byQuestId_s[this.co_markets_ac[index_n].ltm_id_s])
            }else{
                this.mapLastIndexClick_n = index_n
            }
        },
        m_changeBounds_f(minLat_n, minLon_n, maxLat_n, maxLon_n){
            let currentGeoHash_as = map_geoHash_bboxes_fp(minLat_n, minLon_n, maxLat_n, maxLon_n)

            if(currentGeoHash_as[0] == null || currentGeoHash_as[0].length <= 2){
                console.log("area to big, user should zoom in")
                return
            }

            currentGeoHash_as.forEach(geoHash_s => {

                let lastGeoHash_s = mao_geoHash_lastHash_fs(geoHash_s)

                let oldHashToRemove_byNewHash_as = {}

                // compare to oldGeoHash
                for(let oldGeoHash_s in this.server_oldGeoHash_byHash_s){
                    let lastOldGeoHash_s = mao_geoHash_lastHash_fs(oldGeoHash_s)

                    // check if already have geoHash
                    if(oldGeoHash_s <= geoHash_s && geoHash_s < lastOldGeoHash_s){
                        return
                    }else if(geoHash_s <= oldGeoHash_s && oldGeoHash_s < lastGeoHash_s){
                        if(oldHashToRemove_byNewHash_as[geoHash_s] == null){
                            oldHashToRemove_byNewHash_as[geoHash_s] = []
                        }
                        oldHashToRemove_byNewHash_as[geoHash_s].push(oldGeoHash_s)
                    }
                }

                // get geoHash
                this.$set(this.server_oldGeoHash_byHash_s, geoHash_s, geoHash_s)
                server_questGeoHash_withGeoHashFilter_getAll_fp(geoHash_s, lastGeoHash_s, (questGeoHash_ac) => {

                    if(oldHashToRemove_byNewHash_as[geoHash_s]){
                        oldHashToRemove_byNewHash_as[geoHash_s].forEach(oldHash_s => {
                            this.$delete(this.server_oldGeoHash_byHash_s, oldHash_s)
                        })
                    }
                    this.$set(this.server_oldGeoHash_byHash_s, geoHash_s, geoHash_s)

                    questGeoHash_ac.forEach(questGeoHash_c => {
                        this.$set(this.server_questGeoHash_byQuestId_c, questGeoHash_c.qg_questId_uid, questGeoHash_c)
                    })
                })

            })

        },

    },
    async created() {

        this.p_questsExplore_ac.forEach(questExplore_c => {
            this.paths_byQuestId_s[questExplore_c.qex_questId_uid] = this.p_linkPrefix_e + "/" + questExplore_c.qex_questId_uid
        })


        let geoLocation_o = await map_getLocationWithIp_fp()
        this.startingLocation_c = new FB_MapPoint({
            mp_lat_n : parseFloat(geoLocation_o.latitude),
            mp_lng_n : parseFloat(geoLocation_o.longitude)
        })

        this.displayQuestNum_n = this.addDisplayQuestNum_n
        this.m_filterQuestExplore_f()
    }
}
</script>

<style scoped>

</style>